import { SagaReturnType, put, call, takeEvery } from 'redux-saga/effects';

import { withdrawActions } from '@modules';

import checkRegularAddress from './check-regular-address';
import { getState } from '../helpers';

function* doCheckAddress(action: SagaReturnType<typeof withdrawActions.setAddress>) {
  const { address, currency } = action.payload;

  const { global } = yield* getState();
  const network = global.currencies.config.default_networks[currency];

  if (!address || !currency) return;

  try {
    const data = { address, currency, network };
    yield call(checkRegularAddress, data);
  } catch (error) {
    yield put(withdrawActions.setAddressLoading(false));
  } finally {
    yield put(withdrawActions.setAddressLoading(false));
  }
}

function* checkAddress() {
  yield takeEvery([withdrawActions.setAddress.type], doCheckAddress);
}

export default checkAddress;
